module.exports = __webpack_public_path__ + "img/zhuanli7.e9280c91.png";